// =============================================
// NÓ: MESSAGE (MENSAGEM WHATSAPP) - MOBILE FIRST
// =============================================
// Arquivo: MessageNode.tsx
// Descrição: Nó para enviar mensagens - otimizado para touch
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface MessageNodeProps {
  data: {
    label?: string;
    message?: string;
    messageType?: 'text' | 'image' | 'video' | 'audio' | 'location' | 'buttons' | 'list';
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const MessageNode: React.FC<MessageNodeProps> = ({ data, selected }) => {
  const getIcon = () => {
    switch (data.messageType) {
      case 'image': return 'fa-image';
      case 'video': return 'fa-video';
      case 'audio': return 'fa-microphone';
      case 'location': return 'fa-map-marker-alt';
      case 'buttons': return 'fa-hand-pointer';
      case 'list': return 'fa-list';
      default: return 'fa-comment-dots';
    }
  };

  return (
    <div className={`custom-node message-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="message-input"
        className="node-handle target-handle"
      />
      <div className="node-icon">
        <i className={`fab fa-whatsapp`}></i>
      </div>
      <div className="node-content">
        <div className="node-label">{data.label || 'Mensagem WhatsApp'}</div>
        {data.message && (
          <div className="node-preview">
            <i className={`fas ${getIcon()}`}></i>
            <span>{data.message.substring(0, 30)}{data.message.length > 30 ? '...' : ''}</span>
          </div>
        )}
        <ActionsBadge actions={data.actions} />
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="message-output"
        className="node-handle source-handle"
      />
    </div>
  );
};

export default MessageNode;
